import component from './experiments.vue'

export default component
